import { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';

import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import CollapsibleSnackBar from 'client/pages/MapPage/components/SnackBars/CollapsibleSnackBar/CollapsibleSnackBar';

import { mdiFilterVariant } from '@mdi/js';

import { mapMenuTabKeys } from 'client/utils/constants/appStates';
import { LOCALES } from 'i18n/locales';
import { useAssetOwnerIsolatedView } from '../../MapMenu/IsolatedViews/useAssetOwnerIsolatedView';
import { sectors, selectSectorSpecificStyles } from 'client/store/layersSlice/layersSlice';
import { logWithPrefix } from 'client/utils/logging';
const log = logWithPrefix('IsolatedViewsSnackBar');
const sectorMap = {
    [sectors.ELECTRICITY]: 'isolatedView.electricitySymbology',
    [sectors.GAS]: 'isolatedView.gasSymbology'
};

const formatAssetCategory = (category, locale) => {
    const localizedCategory = category?.[locale] || category?.[LOCALES.ENGLISH];
    if (!localizedCategory) {
        return '';
    }

    return `- ${localizedCategory.toLocaleLowerCase(locale)} `;
};

const formatSectorSpecificText = (intl, enabled, sector) => {
    if (!enabled || !sector) {
        return '';
    }

    return ` (${intl.formatMessage({ id: sectorMap[sector] })})`;
};

const IsolatedViewsSnackBar = () => {
    const intl = useIntl();
    const [visible, setVisible] = useState(false);

    const selectedTab = useSelector(state => state?.map?.menuSelectedTab);
    const { enabled, sector } = useSelector(selectSectorSpecificStyles, shallowEqual);
    const { id, actorName, category } = useAssetOwnerIsolatedView();

    useEffect(() => {
        const validMode = selectedTab === mapMenuTabKeys.ISOLATED_VIEWS && id && actorName;
        setVisible(validMode);
    }, [selectedTab, id, actorName]);

    const type = formatAssetCategory(category, intl.locale);
    const sectorSpecific = formatSectorSpecificText(intl, enabled, sector);
    return (
        <>
            {visible && <SnackBar variant="warning" >
                <CollapsibleSnackBar
                    icon={mdiFilterVariant}
                    label={intl.formatMessage({ id: 'isolatedView.notification.label' })}
                    expandSignal={id + '-' + type + '-' + sectorSpecific}
                    data-testid="isolatedViewSnackBar.alert"
                    onUserCollapse={() => log('User collapsed isolated views snackbar')}
                    onUserExpand={() => log('User expanded isolated views snackbar')}
                    onExpand={() => log('Isolated views snackbar expanded automatically')}
                >
                    <FormattedMessage
                        id={'isolatedView.alert'}
                        values={{
                            strong: chunks => <strong>{chunks}</strong>,
                            br: <br />,
                            assetOwner: actorName,
                            type,
                            sectorSpecific
                        }}
                    />
                </CollapsibleSnackBar>
            </SnackBar>
            }
        </>
    );
};

export default IsolatedViewsSnackBar;
